<template>
    <div id="user-info">
        <div id="introduction">
            <div id="head">
                <div class="info">
                    <img-lazy :src="userInfo.avatar | thumbnail(160, 160)" :bg="false" class="avatar"/>
                    <div class="name-wrapper">
                        <h3 id="name">{{ userInfo.name }}</h3>
                        <span @click=" $router.push('/wxappUserInfo/social/1')" class="fans">
                            <span>粉丝</span>
                            <span>{{ userInfo.fans }}></span>
                        </span>
                         <span @click="$router.push('/wxappUserInfo/social/0')" class="attention">
                            <span>关注</span>
                            <span>{{ userInfo.follow }}></span>
                        </span>
                    </div>
                </div> 
                <div class="tabs">
                    <span class="album" :class="{active: isShowList}" @click="isShowList=!isShowList">相册</span>
                    <span class="collect" :class="{active: !isShowList}"  @click="isShowList=!isShowList">收藏</span>
                </div>
            </div>    
        </div>

        <div id="list" v-if="isShowList">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    @load="onLoad"
            >
                <div class="talk" v-for="(item, key) in list" :key="item.id">
                    <div class="date">
                        <span class="day">{{ parseDate(item.createTime, 2) }}</span>
                        <span class="month">{{ parseDate(item.createTime, 1) }}月</span>
                    </div>
                    <div class="album" v-if="item.type===0 || item.type === 1">
                        <img v-for="(image, k) in item.album" v-if="k < 4" v-lazy="thumbnail(image, item.album.length)"
                             @click="preview(item.album, k, key)" :class="{single: item.album.length === 1}"/>
                        <span v-if="item.video" class="play"><i class="iconfont icon-bofang1"></i></span>
                    </div>
                    <div class="content" v-if="item.type===0 || item.type === 1">
                        <div :class="`line-clamp-${item.album.length === 2 ? 2 : 3}`" class="item-content" v-html="item.content"></div>
                        <span class="count">共{{ item.album.length }}张</span>
                        <span class="delete" v-if="isSelf" @click="onTalkDelete(item, key)">删除</span>
                    </div>
                    <div v-if="item.type === 2" class="article">
                        <div class="share">{{ item.content }}</div>
                        <div class="headline" @click="GotoArticle(item.link.url)">
                            <img :src="item.link.thumbnail | thumbnail(60,60)" alt=""> 
                            <span class="description">{{ item.link.description }}</span>
                        </div>
                        <div class="remove" v-if="isSelf" @click="onTalkDelete(item, key)">删除</div>
                    </div>
                    
                </div>
            </van-list>
        </div>
        
        <Favorite v-else></Favorite>

        <van-popup v-model="showVideo" style="width: 100%; height:70%; background-color:rgba(0,0,0,1)" :overlay-style="{'background-color': 'rgba(0,0,0,1)'}" @close="closeVideo">
          <video :src="videoSrc" controls autoplay loop playsinline id="video"></video>
        </van-popup>
    </div>
</template>

<script>
    
    import {
        NavBar,
        Icon,
        List,
        Cell,
        Lazyload,
        ImagePreview,
        Button,
        Popup,
        Toast,
        Dialog,
        Uploader
    } from 'vant';
    import ImgLazy from '@/components/ImgLazy';
    import ImgSrc from '@/assets/ImgSrc';
    import Favorite from './Favorite'
    import {mapMutations} from 'vuex'

    const LazyloadOptions = {
        loading: `${ImgSrc.IMG_DEFAULT}?imageView2/1/w/160/h/164`,
        error: `${ImgSrc.IMG_ERROR}?imageView2/1/w/160/h/164`,
        preload: `${ImgSrc.IMG_DEFAULT}?imageView2/1/w/160/h/164`
    };
    import Vue from 'vue';
    Vue.use(NavBar).use(Icon).use(List).use(Cell).use(Lazyload, LazyloadOptions).use(Button).use(Popup).use(Toast).use(Dialog).use(Uploader);//.use(Croppa)

    const preAlbum = [
        ['http://img.tutubox.cn/user-info-Brooch@2x.png',
            'http://img.tutubox.cn/user-info-Brooch@2x1.png'],
        ['http://img.tutubox.cn/user-info-Earrings@2x.png',
            'http://img.tutubox.cn/user-info-Earrings@2x1.png'],
        ['http://img.tutubox.cn/user-info-Hand_ring@2x.png',
            'http://img.tutubox.cn/user-info-Hand_ring@2x1.png'],
        ['http://img.tutubox.cn/user-info-Necklace@2x.png',
            'http://img.tutubox.cn/user-info-Necklace@2x1.png'],
        ['http://img.tutubox.cn/user-info-Ring@2x.png',
            'http://img.tutubox.cn/user-info-Ring@2x1.png']
    ];

    export default {
        components: {ImgLazy, Favorite},

        name: 'UserInfo',

        data() {
            return {
                id: 0,
                isSelf: 1,
                // userId: 0,
                albumPopupShow: false,
                albumKey: 0,
                showCroppa: false,
                croppa: {},
                userInfo: {
                    album: [],
                    avatar: '',
                    fans: 0,
                    fansUserIds: [],
                    favorite: 0,
                    follow: 0,
                    followUserIds: [],
                    introduction: '',
                    like: 0,
                    likeUserIds: [],
                    name: '',
                    userId: 0,
                    qrCode: ''
                },
                list: [],
                loading: false,
                finished: false,
                form: {
                    page: 1,
                    pageSize: 20,
                    userId: 0,
                    focus: false
                },
                showQrCode: false,
                appImgSave: false,
                isApp: false,
                wx: null,
                showVideo: false,
                videoSrc: '',
                isShowList: true
            }
        },
       
        methods: {
            onTalkDelete(item, key) {
                Dialog.confirm({
                    message: '确定删除?'
                }).then(() => {
                    this.$http.post('/api/talk/delete', {id: item.id}).then(() => {
                        Toast('删除成功');
                        this.list.splice(key, 1);
                    });
                }).catch(() => {
                });
            },
          
            onLike(key) {
                if (-1 === key) {
                    this.$http.post('/api/user_more/like', {id: this.userInfo.userId}).then(() => {
                        Toast('点赞成功~');
                        this.userInfo.like++;
                        this.userInfo.likeUserIds.push(this.$store.state.userInfo.userId);
                    });
                } else {
                    let album = this.hasAlbum(key, 6);
                    if (album && album.likeUserIds.includes(this.$store.state.userInfo.userId)) {
                        Toast('已点赞~');
                        return;
                    }
                    this.$http.post('/api/album/like', {
                        type: key,
                        userId: this.userInfo.userId
                    }).then(() => {
                        Toast('点赞成功~');
                        if (album) {
                            album.like++;
                            album.likeUserIds.push(this.$store.state.userInfo.userId);
                        }
                    });
                }
            },
            onLoad() {
                // 写个恶心的延时算法
                if (this.form.userId === 0) {
                    setTimeout(() => {
                        this.onLoad();
                    }, 200);
                    return;
                }
                this.loading = true;
                if(this.$route.params.id) {
                    this.form.userId = this.$route.params.id
                }
                this.$http.post('/api/talk/page', this.form).then(data => {
                    this.form.page++;
                    data.forEach(item => {
                        this.loading = false;
                        let exist = false;
                        //去重复
                        this.list.forEach(i => {
                            if (i.id === item.id) {
                                exist = true;
                                return false;
                            }
                        });
                      if (!exist) {
                        item.commentSwitch = false;
                        //fixme:OSS未支持https,兼容处理
                        item.avatar = item.avatar.replace(/(https?:)?\/\//, 'http://')
                        item.album.forEach((image, i) => {
                          item.album[i] = image.replace(/(https?:)?\/\//, 'http://')
                        });
                        this.list.push(item);
                      }
                    });

                    //没了
                    if (data.length < this.from.pageSize) {
                        this.finished = true;
                    }
                }).catch(() => {
                    this.loading = false;
                    this.finished = true;
                });
            },

            hasAlbum(key, type = 0) {
                let album = {};
                this.userInfo.album.forEach((item, i) => {
                    if (key === item.type) {
                        // 删除
                        if (4 === type) {
                            this.userInfo.album.splice(i, 1);
                        } else {
                            album = item;
                        }
                        return false;
                    }
                });
                let exist = album.url || false;
                if (0 === type) {
                    return exist && true;
                } else if (4 === type) {
                    return true;
                } else if (5 === type) {
                    // 点赞
                    return album.like || 0;
                } else if (6 === type) {
                    // 对象
                    return exist ? album : false;
                } else if (1 === type) {
                    return `${exist || preAlbum[key][1]}?imageView2/1/w/80/h/80`;
                } else if (2 === type) {
                    return `${exist || preAlbum[key][0]}?imageView2/1/w/500/h/500`;
                } else if (7 === type) {
                    return exist && album.likeUserIds.includes(this.$store.state.userInfo.userId);
                }
            },

            onFocus(userId, type = 1) {
                if (1 === type) {
                    this.$http.post('/api/user_more/follow', {id: userId}).then(() => {
                        Toast('关注成功');
                        let followUserIds = [...this.$store.state.userInfo.followUserIds];
                        followUserIds.push(userId);
                        this.$store.commit('USER_INFO', {
                            follow: this.$store.state.userInfo.follow + 1,
                            followUserIds
                        });
                    });
                } else {
                    this.$http.post('/api/user_more/unFollow', {id: userId}).then(() => {
                        Toast('已取消关注');
                        let followUserIds = [...this.$store.state.userInfo.followUserIds];
                        let index = followUserIds.indexOf(userId);
                        followUserIds.splice(index, 1);
                        this.$store.commit('USER_INFO', {
                            follow: this.$store.state.userInfo.follow + 1,
                            followUserIds
                        });
                    });
                }
            },

            isFocused(userId) {
                return this.$store.state.userInfo.followUserIds.indexOf(userId) > -1;
            },

            thumbnail(url, length) {
                return length === 1 ? `${url}?imageView2/1/w/176/h/176` : `${url}?imageView2/1/w/80/h/80`;
            },
            preview(album, index = 0, key) {
                if(this.list[key].video) {
                    this.showVideo = true;
                    this.videoSrc = this.list[key].video
                }else {
                    ImagePreview(album, index);
                }
            },

            parseDate(time, type = 'day') {
                let date = time.split(/[- : \/]/);
                // return date[type].replace(/0/,"") 把后面的0也去掉了
                return date[type].replace(/\b(0+)/gi,"");
            },
         

            GotoArticle(site) {  
                this.$router.push(site.split('#')[1])

            },

            closeVideo() {
                this.videoSrc = ''
            },
          
            ...mapMutations({
                setPhotoPreview: 'SET_PHOTO_PREVIEW'
            })
        },

        created() {
            
        },

        activated() {
           
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.list = [];
                vm.loading = false;
                vm.finished = false;
                vm.form.page = 1;
                // vm.isSelf = (to.path === '/my');
                
                  vm.$store.dispatch('RefreshUserInfo').then(data => {

                    //fixme:OSS未支持https,兼容处理
                    data.avatar = data.avatar.replace(/(https?:)?\/\//, 'http://');
                    data.album.forEach((item, i) => {
                      data.album[i].url = item.url.replace(/(https?:)?\/\//, 'http://');
                    });

                    vm.userInfo = data;
                    vm.form.userId = data.userId;
                  });
                // } else {
                //     let userId = parseInt(vm.$route.params.id);
                //     vm.$http.post('/api/user_more/info', {userId}).then(data => {
                //         vm.userInfo = data;
                //         vm.form.userId = data.userId;
                //     });
                // }
            });
        }
    };
</script>

<style scoped lang="less">
    #user-info {
        #introduction {
            #head{
                min-height: 210px;
                background-image: url('../../assets/frame-img/bg.jpg');
                background-size:100% 100%;
                background-repeat:no-repeat;
                .info{
                    display: flex;
                    padding: 50px;
                    padding-left: 16px;
                    .avatar {
                        width: 60px;
                        height: 60px; 
                        border-radius: 50%; 
                    }
                    .name-wrapper{
                        padding-left: 25px;
                        padding-top: 10px;
                        #name {
                            font-size: 16px;
                            color:rgba(255,255,255,1);
                        }
                        .fans{
                            font-size: 12px;
                            color: #fff;
                            margin-right: 10px;
                        }
                        .attention{
                            font-size: 12px;
                            color: #fff;
                        }
                    }
                }
                .tabs{
                    text-align: center;
                    color: #fff;
                    font-size: 14px;
                    .active{
                        border-bottom: 1px solid #fff; 
                    }
                    .album{
                        padding: 3px 6px;
                        margin-right: 50px;
                    }
                    .collect{
                        padding: 3px 6px;
                    }
                }
               
            }
        }

        #list {
            margin-top: 10px;
            .talk {
                display: flex;
                padding: 10px 20px 10px 10px;
                .date {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    width: 80px;
                    flex: none;
                    .day {
                        font-size: 38px;
                        line-height: 16px;
                    }
                    .month {
                        font-size: 16px;
                    }
                }
                .album {
                    width: 88px;
                    max-height: 88px;
                    min-height: 60px;
                    vertical-align: middle;
                    margin-left: 5px;
                    flex: none;
                    position: relative;
                    img {
                        width: 40px;
                        height: 40px;
                        margin: 2px;
                    }
                    img.single {
                        width: 88px;
                        height: 88px;
                        margin: 2px;
                    }
                    .play{
                        position: absolute;
                        top: 35%;
                        left: 35%;
                        .iconfont{
                            font-size: 35px;
                            color: #fff;
                        }
                    }
                }
                .content {
                    margin-left: 5px;
                    max-height: 88px;
                    overflow: hidden;
                    position: relative;
                    min-width: 100px;
                    font-size: 16px;
                    > span {
                        font-size: 12px;
                    }
                    .item-content{
                        max-height: 65px;
                        overflow: hidden;
                        padding-bottom: 5px;

                    }
                    .count {
                        position: absolute;
                        left: 0;
                        bottom: 0;
                    }
                    .delete {
                        position: absolute;
                        left: 40px;
                        bottom: 0;
                        color: cornflowerblue;
                    }
                }
                .article{
                    .share{
                        margin-left: 5px;
                        font-size: 16px;
                    }
                    .headline{
                        display: flex;
                        align-items: center;
                        margin-left: 5px;
                        background-color: #EEEEEE;
                        height: 60px;
                        .description{
                            font-weight:500;
                            color:rgba(34,34,34,1);
                            font-size: 12px;
                            margin-left: 12px;
                            margin-right: 8px;
                            text-overflow:ellipsis;
                            // white-space:;
                            white-space: nowrap;
                            overflow:hidden;
                            width: 180px;
                        }
                    }
                    .remove{
                        // text-align: right;
                        margin-left: 5px;
                        font-size: 12px;
                        color: cornflowerblue;
                    }
                }
                
                
            }
        }


        #video{
          width: 100%;
          height: 100%;
        }

        /deep/ .van-popup {
            overflow: visible;
        }
        #album-show-popup {
            border-radius: 5px;
            img {
                width: 300px;
                height: 300px;
            }
            > div {
                text-align: center;
                > div {
                    margin: 25px;
                    i {
                        font-size: 40px;
                        padding: 15px 14px 10px 11px;
                        border-radius: 50%;
                        color: #bea473;
                        background-color: black;
                    }
                }
            }
            p {
                font-size: 16px;
                margin-bottom: 10px;
            }
            > #uploader {
                position: absolute;
                top: 10px;
                right: 10px;
            }
            > i {
                border-radius: 50%;
                background-color: white;
                padding: 10px;
            }
            .van-uploader {
                position: absolute;
                top: 20px;
                right: 20px;
            }
        }

        #croppa-show-popup {
            background-color: initial;
            #button-cropped-image {
                font-size: 1.2rem;
                color: #4b0;
                position: fixed;
                top: 90%;
                left: 50%;
                -webkit-transform: translate3d(-50%, 100%, 0);
                transform: translate3d(-50%, 100%, 0);
                -webkit-transition: .2s ease-out;
                transition: .2s ease-out;
            }
        }
        /deep/ .van-popup{
        //   height: 320px;
          border-radius: 10px;
          padding: 10px 0;
          text-align: center;  
          img{
            width: 250px;
            height: 250px;
            margin-bottom: 23px;
          }
          .WeChat-qrCode{
            font-size:14px;
            font-weight:400;
            color:rgba(36,13,41,1);
          }
        }  
         .popup-content{
          div{
              text-align: center;
              height: 50px;
              line-height: 50px;
              background-color: #fff;
              font-size: 18px;
          }
          .popup-save{
              border-bottom: 1px solid #dad5db;
          }
          
        }
    }

    /deep/ [class*=van-hairline]::after {
        border: none;
    }
</style>

